import React from 'react'

function FormInput({ value, placeholder, updateField, className, field }) {
  return (
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      className={className}
      onChange={(e) => {
        e.preventDefault();
        updateField(field, e.target.value)
      }}
    />
  )
}

export default FormInput;